module.exports = __webpack_public_path__ + "media/images/team-f6a03cf4.png";